export { BadgeList } from './BadgeList';
//# sourceMappingURL=index.js.map